import React from 'react'
import { useIntl } from 'hooks'
import './index.css'

const Index = ({ children }) => {
    const { t } = useIntl()

    return (
        <>
            <div className="shared-patient-wrapper">
                <div className="shared-patient-form">
                    <div className="form-label-row">
                        <span>{t('label.shared.with')}</span>
                    </div>
                    <div className="file-shared-area">{children}</div>
                </div>
            </div>
        </>
    )
}

export default Index
